import type { NavbarItem } from '../Navbar';
import { groupMainNavSections } from '../Navbar/navSections';
import type { RailCustomNode } from './Rail';

export type RailSection = {
  label: string;
  items: (NavbarItem | RailCustomNode)[];
  hideLabel?: boolean;
  fixed?: boolean;
};

// En el riel el Centro de ayuda no es una fila: es un botón chico arriba, junto a la
// campana (JP, 19/10). El menú del celular lo sigue mostrando como fila.
export const RAIL_HELP_LABEL = 'Centro de ayuda';

export const buildRailSections = (mainItems: NavbarItem[], dropdownItems: NavbarItem[]): RailSection[] => {
  const { sections, systemItems, rest } = groupMainNavSections([...mainItems, ...dropdownItems]);
  return [
    ...sections,
    ...(rest.length ? [{ label: 'Otros accesos', items: rest }] : []),
    {
      label: 'Ayuda y cuenta',
      hideLabel: true,
      fixed: true,
      items: systemItems.filter((item) => item.label !== RAIL_HELP_LABEL)
    }
  ];
};
